module.exports = "/_next/static/images/heartinhand-duotone-e690828052e626529cdbaf7f0c6bbdea.svg";